export const SET_SCROLL_TO_TOP = 'scroll/SET_SCROLL_TO_TOP';
